var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3977 10.0821L16.4013 11.9154C16.404 13.3156 16.4053 14.0156 16.1339 14.5509C15.8951 15.0218 15.5134 15.405 15.0434 15.6456C14.5092 15.9191 13.8091 15.9204 12.409 15.9231L10.5757 15.9267M7.21345 0.933106L5.38012 0.936636C3.97999 0.939331 3.27993 0.940679 2.74567 1.21419C2.27573 1.45478 1.89402 1.83797 1.65524 2.30883C1.38378 2.84414 1.38513 3.5442 1.38783 4.94433L1.39136 6.77766M11.3897 5.92508L16.3801 0.91546M16.3801 0.91546L11.3801 0.925085M16.3801 0.91546L16.3897 5.91545M6.39937 10.9347L1.409 15.9443M1.409 15.9443L6.40899 15.9347M1.409 15.9443L1.39938 10.9443",
    stroke: "#B8C5CC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/expand-icon.de73e4e07054eff7487f624585700e4a.svg";
export { ForwardRef as ReactComponent };